import { render } from "./wage-employee-competences.vue?vue&type=template&id=799b392d"
import script from "./wage-employee-competences.vue?vue&type=script&lang=js"
export * from "./wage-employee-competences.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/applications/wagesetting/wage-employee-competences.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "799b392d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('799b392d', __exports__)) {
    api.reload('799b392d', __exports__)
  }
  
  module.hot.accept("./wage-employee-competences.vue?vue&type=template&id=799b392d", () => {
    api.rerender('799b392d', render)
  })

}


export default __exports__